import apis from './apis';

export const getCollectionDates = ({ countryCode, postcode }) =>
  apis.get('collections/dates', {
    params: {
      countryCode,
      postcode,
    },
  });
